<div [id]="'opta-average-positions_' + template"></div>
